import { useQuery } from "@tanstack/react-query";
import { County, ForecastCityDto } from "services/iot/models";
import { createService } from "services/serviceFactory";

const iotService = createService("iot");
const iotBase = "/iot/";

export const useCountiesQueries = () => {
    const results = useQuery({
        queryKey: ["iot", "counties"],
        queryFn: async () => {
            const response = await iotService.get<County[]>(`${iotBase}Sifarnici/ZupanijeAsync`);
            return response.data;
        },
        staleTime: 5 * 60 * 1000,
    });

    const countiesQuery = results;

    return {
        countiesQuery,

        isLoading: results.isLoading,
        isError: results.isError,

        counties: countiesQuery.data ?? [],
    };
};

export const useCitiesQueries = () => {
    const results = useQuery({
        queryKey: ["iot", "cities"],
        queryFn: async () => {
            const response = await iotService.get<ForecastCityDto[]>(
                `${iotBase}Sifarnici/GetForecastCitiesAsync`
            );

            return response.data;
        },
        staleTime: 5 * 60 * 1000,
    });

    const citiesQuery = results;

    return {
        citiesQuery,

        isLoading: results.isLoading,
        isError: results.isError,

        cities: citiesQuery.data ?? [],
    };
};
